import { Typography } from "../ui";
import type { CSSProperties, ReactNode } from "react";
import "./DetailList.css";

const { Text } = Typography;

export type DetailListProps = {
  children: ReactNode;
  className?: string;
  id?: string;
  style?: CSSProperties;
};

export type DetailFieldProps = {
  label: ReactNode;
  children: ReactNode;
  className?: string;
};

/**
 * Einheitliche einspaltige Darstellung für schreibgeschützte Detaildaten.
 *
 * Der Abstand innerhalb eines Label-Wert-Paars ist bewusst kleiner als der
 * Abstand zwischen zwei Feldern. Texte und Aktionen werden bereits übersetzt
 * beziehungsweise fertig gerendert übergeben.
 */
export function DetailList({ children, className, id, style }: DetailListProps) {
  return (
    <dl
      id={id}
      className={["mq-detail-list", className].filter(Boolean).join(" ")}
      style={style}
    >
      {children}
    </dl>
  );
}

export function DetailField({ label, children, className }: DetailFieldProps) {
  return (
    <div className={["mq-detail-field", className].filter(Boolean).join(" ")}>
      <dt className="mq-detail-field-label">
        <Text type="secondary">{label}</Text>
      </dt>
      <dd className="mq-detail-field-value">{children}</dd>
    </div>
  );
}
